export const getPenStudyFlowId = state => state.penStudyFlows.penStudyFlow.id;
export const getPenStudyFlowData = state => state.penStudyFlows.penStudyFlow;
export const penStudyFlowIsFetching = state => state.penStudyFlows.loading;